import { AmmunitionStockEventResolverBase } from './ammunition-stock-event.resolver.base';
import { AmmunitionStockEventService } from './ammunition-stock-event.service';
import { Injectable } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class AmmunitionStockEventResolver extends AmmunitionStockEventResolverBase {

  constructor(protected service: AmmunitionStockEventService) {
    super(service);
  }
}



